export const cifAz = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#0098C3' d='M.5.5h300v150H.5z'/><path fill='#E00034' d='M.5 50.5h300v50H.5z'/><path fill='#00AE65' d='M.5 100.5h300v50H.5z'/><circle fill='#FFF' cx='145.75' cy='75.5' r='22.5'/><circle fill='#E00034' cx='150.5' cy='75.5' r='18.75'/><path fill='#FFF' d='M179.595 84.333l-6.449-3.06L170.759 88l-2.396-6.724-6.445 3.069 3.06-6.449-6.727-2.387 6.724-2.396-3.069-6.445 6.449 3.06L170.742 63l2.396 6.724 6.445-3.069-3.06 6.449 6.728 2.387-6.724 2.396z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-az.js
// module id = null
// module chunks = 